import { render, staticRenderFns } from "./DropdownButton.vue?vue&type=template&id=8e6c7ae6&scoped=true&"
import script from "./DropdownButton.vue?vue&type=script&lang=ts&"
export * from "./DropdownButton.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownButton.vue?vue&type=style&index=0&id=8e6c7ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6c7ae6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
